import {memo, RefObject, useCallback, useState} from 'react';
import {InputAction} from '../../atoms/input-action';
import {EyeIcon} from '../../atoms/icons';
import {EyeOffIcon} from '../../atoms/icons';
import styled from 'styled-components';
import {getColorFromTheme} from '../../ui-utils';

export interface PasswordInputEyeToggleProps {
  inputRef: RefObject<HTMLInputElement>;
}

export const PasswordToggleIconSurface = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  line-height: 1.7;
  color: ${getColorFromTheme('textBody')};
  background-color: transparent;
  outline: none;
`;

const PasswordAction = styled(InputAction)`
  width: 24px;
  height: 24px;
  padding: 0;
`;

export const PasswordInputEyeToggle = memo(function ({
  inputRef,
}: PasswordInputEyeToggleProps) {
  const [visible, setVisible] = useState(inputRef.current?.type === 'password');

  const onClick = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.setAttribute(
        'type',
        inputRef.current.type === 'password' ? 'text' : 'password',
      );
      setVisible(!visible);
    }
  }, [inputRef, visible]);

  return (
    <PasswordAction
      children={
        visible ? (
          <PasswordToggleIconSurface>
            <EyeOffIcon />
          </PasswordToggleIconSurface>
        ) : (
          <PasswordToggleIconSurface>
            <EyeIcon />
          </PasswordToggleIconSurface>
        )
      }
      size="lg"
      kind="textDark"
      onClick={onClick}
    />
  );
});

PasswordInputEyeToggle.displayName = 'PasswordInputEyeToggle';
